import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styles: [
  ]
})
export class AppHeaderComponent implements OnInit {
 logoHeight = "25";
  showPhone = true;
  showEmail = true;
  showSite = true;
  siteLabel = 'Customer Service';
 
  constructor(  private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.get('header.logoHeight').subscribe(logoHeight => {
      this.logoHeight = logoHeight;
    })
    this.translate.get('support').subscribe(support => {
      this.showPhone = !!support.phone;
      this.showEmail = !!support.email;
      this.showSite = !!support.site;
      this.siteLabel = support['site-label'];
    })
  }

}
